import { render } from "./CreateRelationButton.vue?vue&type=template&id=27c51fcc"
import script from "./CreateRelationButton.vue?vue&type=script&lang=js"
export * from "./CreateRelationButton.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"CreateRelationButton.vue"]])

export default __exports__